export const CERTIFY_ACTION = {
  WITH_VALUE: "certifyWithValue",
  AT_100: "certifyAt100",
}

const ONE_HOUR_MS = 3600000

export const getStoredDecision = projectId => {
  if (!projectId) return null

  try {
    const key = `certAbove100Decision_${projectId}`
    const stored = localStorage.getItem(key)
    if (!stored) return null

    const decision = JSON.parse(stored)
    const now = Date.now()

    if (now - decision.timestamp >= ONE_HOUR_MS) {
      localStorage.removeItem(key)
      return null
    }

    return decision
  } catch (error) {
    console.error("Error reading stored decision:", error)
    return null
  }
}

export const saveDecision = (projectId, action) => {
  if (!projectId) return

  try {
    const key = `certAbove100Decision_${projectId}`
    const decision = {
      action: action,
      timestamp: Date.now(),
    }
    localStorage.setItem(key, JSON.stringify(decision))
  } catch (error) {
    console.error("Error saving decision:", error)
  }
}
